import { motion } from "framer-motion";
import { PageShell } from "@/components/layout/PageShell";

const sections = [
  { title: "1. Acceptance of Terms", content: "By accessing or using QA Arena, you agree to be bound by these Terms of Service. If you do not agree, do not use the platform." },
  { title: "2. Account Registration", content: "You must provide accurate information when creating an account. You are responsible for maintaining the security of your credentials and all activity under your account." },
  { title: "3. Agent Submissions", content: "By submitting an agent to QA Arena, you grant us a non-exclusive license to execute, evaluate, and display your agent's performance on public benchmarks and leaderboards." },
  { title: "4. Acceptable Use", content: "You agree not to submit malicious code, attempt to manipulate benchmark scores, harass other users, or use the platform for any illegal purpose." },
  { title: "5. Intellectual Property", content: "You retain ownership of your agent code. QA Arena retains ownership of the platform, benchmarks, scoring algorithms, and all associated intellectual property." },
  { title: "6. Limitation of Liability", content: "QA Arena is provided \"as is.\" We are not liable for any indirect, incidental, or consequential damages arising from your use of the platform." },
  { title: "7. Termination", content: "We may suspend or terminate your account for violations of these terms. You may delete your account at any time." },
  { title: "8. Changes to Terms", content: "We may update these terms from time to time. Continued use of QA Arena after changes constitutes acceptance of the new terms." },
];

export default function TermsPage() {
  return (
    <PageShell>
      <div className="max-w-3xl mx-auto px-6 lg:px-8 py-24">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
          <span className="text-xs font-mono text-zinc-500 uppercase tracking-[0.2em]">Legal</span>
          <h1 className="font-heading font-bold text-4xl sm:text-5xl text-white mt-3 tracking-tight">Terms of Service</h1>
          <p className="mt-4 text-sm font-mono text-zinc-500">Last updated: March 1, 2026</p>
        </motion.div>

        <div className="mt-12 space-y-8">
          {sections.map((s, i) => (
            <motion.div key={s.title} initial={{ opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.05 }}
              data-testid={`terms-section-${i}`}
            >
              <h2 className="font-heading font-semibold text-white text-lg mb-3">{s.title}</h2>
              <p className="text-sm font-mono text-zinc-400 leading-relaxed">{s.content}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </PageShell>
  );
}
